import React from 'react'
import '../estilos/QuieneSomos.css'
import heroBeach from '../img-etc/hero-beach.jpg'
import logo from '../img-etc/logo.png'
import { useTranslation } from 'react-i18next';

function HeroSection() {
  const { t } = useTranslation();
  return (
    <section
      className="hero-quienes"
      style={{ backgroundImage: `url(${heroBeach})` }}
    >
      <div className="hero-quienes-overlay"></div>
      <div className="hero-quienes-content">
        <img
          src={logo}
          alt="Pacific Tours Logo"
          className="hero-quienes-logo"
        />
        <h1 className="hero-quienes-title">Pacific Tours CR</h1>
        <p className="hero-quienes-subtitle">
          Costa Rica • Tour Operator • Central America
        </p>
      </div>
    </section>
  )
}

export default HeroSection